<template>
  <div id="MyAdderss">
    <div class>
      <!-- <yd-search v-model="searchName" v-bind:on-submit="FromSubmit" cancel-text placeholder="请输入姓名/校内号"></yd-search> -->
      <van-search v-model="searchName" placeholder="请输入姓名/用户名" @search="FromSubmit" clearable />
    </div>
    <div id="Address">
      <div id="scrollBody">
        <van-list
          v-model="isRefresh" @load="onLoad" finished-text="没有更多了" :finished="finished">
          <ul class="scrollList">
            <li v-for="(item,index) of AddressList" v-bind:key="index">
              <div class="box-body van-hairline--bottom">
                <h3 class="clearfix">
                  <b class="fl" v-cloak>{{item.FullName}}</b>
                  <span class="fr" v-cloak>{{item.SchoolDistrictName}}</span>
                </h3>
                <div style="margin-bottom:6px;margin-top: 20px;">手机</div>
                <div
                  style="border-bottom:1px solid #eee;margin-bottom:10px;padding-bottom:10px;"
                  v-cloak
                >{{item.PhoneNumber}}</div>
                <div style="margin-bottom:6px;">邮箱</div>
                <div style="font-size:16px;" v-cloak>{{item.EmailAddress}}</div>
              </div>
            </li>
          </ul>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchName: '',
      AddressList: [],
      isRefresh: false,
      finished: false,
      totalItems: 0,
      pageIndex: 0,
      pageSize: 10,
    };
  },
  components: {},
  created: function() {
    // this.requestList();
  },
  mounted: function() {},
  methods: {
    //请求数据
    async requestList() {
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/Address/GetTeachers",
        {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          searchName: this.searchName
        }
      );
      this.xy.unloading();
      // xy.http.get(xy.string.format("{0}/api/Address/GetTeachers", xy.subMenuServiceUrl),  function (res) {
      if (res.success) {
        // 加载状态结束
        this.isRefresh = false;
        if (res.data.data && res.data.data.length) {
          this.totalItems = res.data.totalRecords
          this.AddressList = this.AddressList.concat(res.data.data)
        } else {
          this.finished = true;
        }
        if (this.AddressList.length >= this.totalItems) {
          this.finished = true;
        }
      }
    },
    FromSubmit() {
      this.finished = false;
      this.pageIndex = 1;
      this.AddressList = [];
      this.requestList();
    },
    onLoad() {
      this.pageIndex++
      this.requestList()
    }
  }
};
</script>
<style lang='less' >
#MyAdderss {
  .scrollList li {
    background: #fff;
    margin-bottom: 12px;
  }
  .box-body {
    border-bottom: 1px solid #eee;
    padding: 24px 20px;
    h3 {
      margin-bottom: 24px;
      font-size: 32px;
      /* font-weight: 700; */
      color: #333;
    }
    div {
      font-size: 28px;
    }
  }
  .van-search{
      background-color: #efeff4!important;
      height: 80px;
  }
  .van-search__content{
      background-color: #fff;
      height: 60px;
  }
}
</style>

